import script from "./LaputaSearchbar.vue?vue&type=script&setup=true&lang=js"
export * from "./LaputaSearchbar.vue?vue&type=script&setup=true&lang=js"

import "./LaputaSearchbar.vue?vue&type=style&index=0&id=35d28d03&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35d28d03"]])

export default __exports__